import { Injectable } from '@angular/core';
import {
  AbstractControlOptions,
  UntypedFormArray,
  Validators,
} from '@angular/forms';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';

@Injectable({
  providedIn: 'root',
})
export abstract class EaSubscriptionBuilder extends PrFormAbstract {
  generate(entity: any, option = {}) {
    let options: AbstractControlOptions = {};
    return this.formBuilder.group(
      {
        accountInformations: this.formBuilder.group({
          financialKnowledgeLevel: [
            entity?.accountInformations?.financialKnowledgeLevel || null,
            Validators.required,
          ],
          realEstateKnowledgeLevel: [
            entity?.accountInformations?.realEstateKnowledgeLevel || null,
            Validators.required,
          ],
        }),
      },
      options,
    );
  }

  get owners() {
    return this.form.get('owners') as UntypedFormArray;
  }
  get accountInformations() {
    return this.form.get('accountInformations') as UntypedFormArray;
  }

  extract() {
    return { ...this.form.value };
  }
}
